module.exports = __webpack_public_path__ + "static/media/teamsIcon.c07cf846.svg";